export const exterior_view06ImageOptions = {
  angle: 'exterior_view06',
  staticOptions: {
    Bowsprit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    SprayHoodType: 1,
    SprayHood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'SprayHoodType',
      dependency: null
    },
    {
      option: 'SprayHood',
      dependency: 'SprayHoodType'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC38/views/exterior_view06.js